
export const htmlDistanceFactor = 0.007;
